import { FC, useMemo } from 'react'

import * as S from './CarouselNavIndicator.styles'

const DEFAULT_PAGE_SIZE = 9

export type CarouselNavItem = { id: string; visited: boolean; pending?: boolean }

type CarouselNavIndicatorProps = {
  className?: string
  pageSize?: number
  navItems: CarouselNavItem[]
  navItemSelectedId?: string
}

export const CarouselNavIndicator: FC<CarouselNavIndicatorProps> = ({
  className,
  pageSize = DEFAULT_PAGE_SIZE,
  navItems,
  navItemSelectedId,
}) => {
  const dots = useMemo(() => {
    if (!navItemSelectedId || navItems.length === 0) {
      return []
    }
    const index = navItems.findIndex(p => p.id === navItemSelectedId)
    const prevItems = navItems.slice(Math.max(0, index - pageSize), index)
    const nextItems = navItems.slice(index + 1, Math.min(index + pageSize, navItems.length))
    for (let tries = pageSize; tries; tries--) {
      const totalDots = prevItems.length + nextItems.length
      if (totalDots + 1 > pageSize) {
        // remove from the longer side
        if (prevItems.length > nextItems.length) {
          prevItems.shift()
        } else {
          nextItems.pop()
        }
      }
    }
    return [...prevItems, navItems[index], ...nextItems].filter(dot => dot).slice(0, pageSize)
  }, [pageSize, navItems, navItemSelectedId])

  return (
    <S.Root className={className}>
      {dots.map(i => (
        <S.Circle
          key={i.id}
          $visited={i.visited}
          $pending={i.pending}
          $selected={i.id === navItemSelectedId}
        />
      ))}
    </S.Root>
  )
}
